import plantumlEncoder from 'plantuml-encoder'

const PLANTUML_SERVER_URL = 'https://www.plantuml.com/plantuml'
const VDITOR_LANGUAGE = 'plantuml-server'

function createSourceDetails(source) {
  const details = document.createElement('details')
  details.className = 'plantuml-source'

  const summary = document.createElement('summary')
  summary.textContent = '查看 PlantUML 源码'

  const pre = document.createElement('pre')
  const code = document.createElement('code')
  code.textContent = source
  pre.appendChild(code)

  details.appendChild(summary)
  details.appendChild(pre)
  return details
}

function setRenderError(container, status, details, message) {
  container.classList.remove('is-loading', 'is-rendered')
  container.classList.add('is-render-error')
  status.setAttribute('role', 'alert')
  status.textContent = message
  if (details) details.open = true
}

function mountDiagram(container, source, options = {}) {
  if (!container || container.dataset.plantumlMounted === 'true') return
  container.dataset.plantumlMounted = 'true'

  const details = options.details || container.querySelector('.plantuml-source')
  const status = container.querySelector('.plantuml-status') || document.createElement('p')
  if (!status.parentElement) container.prepend(status)
  status.className = 'plantuml-status'
  status.setAttribute('role', 'status')
  status.setAttribute('aria-live', 'polite')
  status.textContent = '正在从 PlantUML 官方服务生成图表…'
  container.classList.add('is-loading')

  if (!source.trim()) {
    setRenderError(container, status, details, 'PlantUML 源码为空，无法生成图表。')
    return
  }

  let imageUrl
  try {
    // plantuml-encoder 输出 PlantUML 默认的 Deflate URL 编码，无需额外格式前缀。
    imageUrl = `${PLANTUML_SERVER_URL}/svg/${plantumlEncoder.encode(source.trim())}`
  } catch (error) {
    console.error('PlantUML 源码编码失败:', error)
    setRenderError(container, status, details, 'PlantUML 源码编码失败，请检查图表内容。')
    return
  }

  const image = document.createElement('img')
  image.className = 'plantuml-image'
  image.alt = options.alt || 'PlantUML 图表'
  if (options.previewable) {
    image.classList.add('diagram-preview-target')
    image.dataset.diagramPreview = 'plantuml'
    image.tabIndex = 0
    image.setAttribute('role', 'button')
    image.setAttribute('aria-label', '放大 PlantUML 图表')
  }
  image.decoding = 'async'
  image.loading = options.eager ? 'eager' : 'lazy'
  image.referrerPolicy = 'no-referrer'
  image.addEventListener('load', () => {
    container.classList.remove('is-loading', 'is-render-error')
    container.classList.add('is-rendered')
    status.hidden = true
  }, { once: true })
  image.addEventListener('error', () => {
    image.remove()
    setRenderError(
      container,
      status,
      details,
      'PlantUML 官方服务暂时不可用，请稍后重试。'
    )
  }, { once: true })

  container.insertBefore(image, details || null)
  image.src = imageUrl
}

export function transformVditorPlantUml(html) {
  if (!/(?:language-plantuml|language-puml)/i.test(html)) return html

  const wrapper = document.createElement('div')
  wrapper.innerHTML = html
  wrapper.querySelectorAll('.language-plantuml, .language-puml').forEach(code => {
    code.classList.remove('language-plantuml', 'language-puml')
    code.classList.add(`language-${VDITOR_LANGUAGE}`)
  })
  return wrapper.innerHTML
}

export function renderVditorPlantUml(root) {
  if (!root || !root.querySelectorAll) return

  root.querySelectorAll(`.language-${VDITOR_LANGUAGE}`).forEach(code => {
    const source = code.textContent || ''
    const codeBlock = code.closest('pre') || code
    const figure = document.createElement('figure')
    figure.className = 'plantuml-preview'

    const caption = document.createElement('figcaption')
    caption.textContent = 'PlantUML 图表'
    const diagram = document.createElement('div')
    diagram.className = 'plantuml-renderer'
    const details = createSourceDetails(source)

    figure.appendChild(caption)
    figure.appendChild(diagram)
    diagram.appendChild(details)
    codeBlock.replaceWith(figure)
    mountDiagram(diagram, source, { details, eager: true })
  })
}

export function renderPlantUmlDiagrams(root) {
  if (!root || !root.querySelectorAll) return

  root.querySelectorAll('[data-plantuml-diagram]').forEach(container => {
    const sourceElement = container.querySelector('[data-plantuml-source]')
    const source = sourceElement ? sourceElement.textContent : ''
    mountDiagram(container, source || '', { previewable: true })
  })
}

export function hasPlantUmlDiagram(content) {
  return /(^|\n)\s*```\s*(?:plantuml|puml)(?:\s|\n)/i.test(String(content || ''))
}
